import { CommonModule } from '@angular/common';
import { InjectionToken, NgModule } from '@angular/core';
import { CustomerCategoryDirective } from './directives/customer-category.directive';
import { CustomerNotDirective } from './directives/customer-not.directive';
import { CustomerDirective } from './directives/customer.directive';
import { UtilsService } from './services/utils.service';
import { TooltipIfOverflowDirective } from './directives/tooltip-if-overflow.directive';

export const TEST_SPLIT_VIEW_SERVICE_ADAPTER: InjectionToken<any> = new InjectionToken<any>(
  'TEST_SPLIT_VIEW_SERVICE_TOKEN'
);

const directives = [CustomerDirective, CustomerNotDirective, CustomerCategoryDirective, TooltipIfOverflowDirective];

@NgModule({
  imports: [CommonModule],
  declarations: [...directives],
  exports: [...directives],
  providers: [UtilsService]
})
export class UtilsModule {}
